import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {QueryFilterDialogComponent} from '../components/query-filter-dialog/query-filter-dialog.component';
import {QueryFilterDialogConfig} from '../query-filter-dialog.config';
import {QueryFilterDialogType} from '../query-filter-dialog.type';
import {TorchQueryFiltersService} from '../../../../../@backend/modules/@filters/torch-query-filters.service';
import {Observable, of} from 'rxjs';
import {TorchQueryFilter} from '../../../../../@backend/modules/@filters/torch-query-filter.model';
import {SavedFilter} from 'ngx-mat-query-search';
import {switchMap, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QueryFilterDialogService {

  constructor(private matDialog: MatDialog,
              private queryFilterService: TorchQueryFiltersService) { }

  manageFilters(entity: string | null = null) {
    this.matDialog.open(QueryFilterDialogComponent, QueryFilterDialogConfig.create(QueryFilterDialogType.MANAGE_FILTERS, null, entity));
  }

  editFilter(id: number) {
    return this.queryFilterService.getFilter(id).subscribe(filter => {
      this.matDialog.open(QueryFilterDialogComponent, QueryFilterDialogConfig.create(QueryFilterDialogType.EDIT_EXISTING, filter));
    });
  }

  pickFilter(entity: string): Observable<TorchQueryFilter | null> {
    return this.matDialog.open(QueryFilterDialogComponent, QueryFilterDialogConfig.create(QueryFilterDialogType.PICK_FILTER, null, entity))
      .afterClosed();
  }

  /**
   * Create a new TorchQueryFilter
   *
   * @param entity - Name of entity used in filter (Discrepancies)
   * @param savedFilter - Value of the SavedFilter
   */
  createNewFilter(entity: string, savedFilter: SavedFilter): Observable<TorchQueryFilter | null> {
    const filter: TorchQueryFilter = {
      entity,
      filterValue: savedFilter.ruleGroup
    };

    return this.matDialog.open(QueryFilterDialogComponent, QueryFilterDialogConfig.create(QueryFilterDialogType.SAVE_NEW, filter))
      .afterClosed().pipe(
        take(1),
        switchMap(queryFilter => {
          if (!!queryFilter) {
            return this.queryFilterService.createFilter(queryFilter);
          }

          return of(null);
        }),
      );
  }
}
